export const ruLettersArr = [...'абвгдеёжзийклмнопрстуфхцчшщъыьэюя'];
export const engLettersArr = [...'abcdefghijklmnopqrstuvwxyz'];
export const numbersArr = [...'0123456789'];

export enum FilterTrigger {
    Default = 'Все',
    Numbers = '0 - 9',
    EngAlphabet = 'A - Z',
    RuAlphabet = 'А - Я',
}
